import React, { useState } from 'react'
import DataTable from './DataTable';
import SectionCard from './SectionCard';
import { assetOptions, componentOptions, escalationOptions, statusOptions, tenantOptions } from '.';
import CustomSelect from './CustomSelect';
import { Grid } from '@mui/material';

const revenueLeasingdata = [
    {
        id: 1,
        sr: 1,
        product: "Fourwrd",
        project: "Indore MMLP",
        component: "ICD",
        status: "Under Discussion",
        partnerName: "PSA",

    },
    {
        id: 2,
        sr: 2,
        product: "-",
        project: "-",
        component: "DCT",
        status: "-",
        partnerName: "-",

    },
    {
        id: 3,
        sr: 3,
        product: "-",
        project: "-",
        component: "PFT",
        status: "-",
        partnerName: "-",
    }
];

const RevenueLeasingNew1 = () => {
    const columns = [
        { field: "sr", headerName: "#" },
        { field: "product", headerName: "Product" },
        { field: "project", headerName: "Project" },
        { field: "component", headerName: "Component" },
        { field: "status", headerName: "Status" },
        { field: "partnerName", headerName: "Partner Name" },
    ];

    const [revenueFilters, setRevenueFilters] = useState({
        asset: "",
        component: "",
        status: "",
        tenant: "",
        escalation: "",
    });

    const handleRevenueFilterChange = (field, value) => {
        setRevenueFilters((prev) => ({
            ...prev,
            [field]: value,
        }));
    };

    return (
        <>
            <SectionCard title="Revenue & Leasing" description="Asset-wise Rental Performance, Lease Terms & Tenant Analytics">
                <Grid container spacing={2}>

                    <Grid size={{ xs: 12, sm: 6, md: 2.4 }}>
                        <CustomSelect
                            name="asset"
                            options={assetOptions}
                            value={revenueFilters.asset}
                            onChange={(e) =>
                                handleRevenueFilterChange("asset", e.value)
                            }
                            placeholder="Asset"
                        />
                    </Grid>

                    <Grid size={{ xs: 12, sm: 6, md: 2.4 }}>
                        <CustomSelect
                            name="component"
                            options={componentOptions}
                            value={revenueFilters.component}
                            onChange={(e) =>
                                handleRevenueFilterChange("component", e.value)
                            }
                            placeholder="Components"
                        />
                    </Grid>

                    <Grid size={{ xs: 12, sm: 6, md: 2.4 }}>
                        <CustomSelect
                            name="status"
                            options={statusOptions}
                            value={revenueFilters.status}
                            onChange={(e) =>
                                handleRevenueFilterChange("status", e.value)
                            }
                            placeholder="Status"
                        />
                    </Grid>

                    <Grid size={{ xs: 12, sm: 6, md: 2.4 }}>
                        <CustomSelect
                            name="tenant"
                            options={tenantOptions}
                            value={revenueFilters.tenant}
                            onChange={(e) =>
                                handleRevenueFilterChange("tenant", e.value)
                            }
                            placeholder="Tenant name"
                        />
                    </Grid>

                    <Grid size={{ xs: 12, sm: 6, md: 2.4 }}>
                        <CustomSelect
                            name="escalation"
                            options={escalationOptions}
                            value={revenueFilters.escalation}
                            onChange={(e) =>
                                handleRevenueFilterChange("escalation", e.value)
                            }
                            placeholder="Escalation"
                        />
                    </Grid>

                </Grid>
            </SectionCard>
            <DataTable columns={columns} data={revenueLeasingdata} />
        </>
    );
}

export default RevenueLeasingNew1
